// ============================================================================
// CANCUN100 — Stepper.js  (APP 2/05 · F1: botón − · número · botón +)
// ----------------------------------------------------------------------------
// Reemplaza las flechitas de <input type="number"> en TODAS las cantidades de la app
// (adultos, menores, infantes, pax, promos, habitaciones, unidades, horas…).
// Los montos de dinero NO usan Stepper: siguen como texto decimal.
//  · 44 px de alto (38 px en la variante chica); botones de 44 px de ancho, cómodos en el teléfono.
//  · El número es type="text" inputmode="numeric": al tocarlo se selecciona todo (focus → select(),
//    mouseup con preventDefault para no perder la selección), así se escribe encima sin borrar.
//  · Solo dígitos; en blur/Enter se ajusta a min/max. Botones deshabilitados en el límite.
//  · Acento: --eq-acento / --eq-tinte (skin del usuario, F4) con respaldo en los tokens dorados de Aurelia.
//  · APP 2/22: el input va con flex 1 1 0 y width 0 (antes flex-basis auto → ~150 px de ancho intrínseco que no encogía
//    y desbordaba la pantalla del celular con tres steppers en fila). El stepper encoge hasta sus dos botones.
// Uso: <Stepper value={n} onChange={(n) => …} min={0} max={99} label="Adultos" chico />
// onChange siempre entrega un NÚMERO ya ajustado a min/max.
// ============================================================================
import React, { useEffect, useState } from 'react';
import { RADIO } from './tema';

export const ACENTO = 'var(--eq-acento-texto, var(--au-gold-solid))';
export const TINTE = 'var(--eq-tinte, var(--au-gold-bg))';
export const BORDE = 'var(--eq-borde, var(--au-gold-border))';

const limpia = (v) => String(v == null ? '' : v).replace(/\D/g, '');

export default function Stepper({ value, onChange, min = 0, max = 99, chico = false, label = '', disabled = false, style, id, ancho }) {
  const num = (v, d) => { const n = parseInt(v, 10); return Number.isFinite(n) ? n : d; };
  const ajusta = (n) => Math.min(max, Math.max(min, n));
  const actual = ajusta(num(value, min));
  const [texto, setTexto] = useState(String(actual));
  useEffect(() => { setTexto(String(actual)); }, [actual]);

  const fija = (n) => {
    const x = ajusta(num(n, min));
    setTexto(String(x));
    if (x !== actual && onChange) onChange(x);
  };
  const alto = chico ? 38 : 44;
  const anchoBtn = chico ? 38 : 44;
  const btn = (txt, d, dis) => (
    <button type="button" tabIndex={-1} disabled={disabled || dis} aria-label={`${d < 0 ? 'Menos' : 'Más'} ${label}`.trim()}
      onClick={() => fija(actual + d)}
      style={{ border: 0, background: TINTE, color: ACENTO, font: 'inherit', fontSize: 22, fontWeight: 600, cursor: disabled || dis ? 'default' : 'pointer', touchAction: 'manipulation', opacity: disabled || dis ? 0.35 : 1, height: '100%', width: anchoBtn, flex: `0 0 ${anchoBtn}px`, padding: 0, lineHeight: 1 }}>
      {txt}
    </button>
  );
  return (
    <div className="c100-stepper" style={{ display: 'flex', height: alto, border: '1px solid var(--au-glass-border-strong)', borderRadius: RADIO, overflow: 'hidden', background: 'var(--au-bg-layer-2)', boxSizing: 'border-box', width: ancho || '100%', minWidth: 0, ...(style || {}) }}>
      {btn('−', -1, actual <= min)}
      <input id={id} type="text" inputMode="numeric" pattern="[0-9]*" value={texto} aria-label={label || undefined} disabled={disabled}
        onFocus={(e) => { const el = e.target; setTimeout(() => { try { el.select(); } catch (_) { /* nada */ } }, 0); }}
        onMouseUp={(e) => e.preventDefault()}
        onChange={(e) => setTexto(limpia(e.target.value).slice(0, 3))}
        onBlur={() => fija(texto === '' ? min : texto)}
        onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); e.target.blur(); } if (e.key === 'ArrowUp') { e.preventDefault(); fija(actual + 1); } if (e.key === 'ArrowDown') { e.preventDefault(); fija(actual - 1); } }}
        size={3} style={{ flex: '1 1 0%', width: 0, minWidth: 0, border: 0, outline: 'none', height: '100%', textAlign: 'center', fontSize: chico ? 15 : 17, fontWeight: 700, fontVariantNumeric: 'tabular-nums', background: 'transparent', color: 'var(--au-text-primary)', padding: '0 4px', fontFamily: 'var(--au-font-text)', boxSizing: 'border-box' }} />
      {btn('+', 1, actual >= max)}
    </div>
  );
}

// Etiqueta pequeña en mayúsculas, igual que FInput, para poner arriba del Stepper.
export const EtiquetaStepper = ({ children, required, centrada }) => (
  <div style={{ fontSize: 12, fontWeight: 500, color: 'var(--au-text-faint)', letterSpacing: '.06em', textTransform: 'uppercase', marginBottom: 4, textAlign: centrada ? 'center' : 'left' }}>
    {children}{required && <span style={{ color: 'var(--au-error-fg)' }}> *</span>}
  </div>
);
